import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

const MODAL_STYLE = {
	base: 'modal',
	afterOpen: 'modal-after-open',
	beforeClose: 'modal-before-close'
};

const OVERLAY_STYLE = {
	base: 'modal-overlay',
	afterOpen: 'modal-overlay-after-open',
	beforeClose: 'modal-overlay-before-close'
};

export default class HFMModal
extends React.Component {
	render () {
		const {
			props,
			props: {
				children,
				styles = {},
				overlayClassName = {}
			}
		} = this;

		return(
			<ReactModal
				shouldCloseOnOverlayClick={ true }
				appElement={ window.document.querySelector('#app') }
				className={ Object.assign({}, MODAL_STYLE, styles) }
				overlayClassName={ Object.assign({}, OVERLAY_STYLE, overlayClassName) }
				{ ...props }
			>
				{ children }
			</ReactModal>
		);
	}
}
